import type { FieldTeamSolutionSlug } from './fieldTeamRoutes';
import { FIELD_TEAM_PATH, SOLUTION_PATHS } from './fieldTeamRoutes';

export const FIELD_TEAM_SEO_KEYWORDS = [
  'field team tracking software',
  'field workforce management software',
  'field operations management',
  'field employee tracking',
  'workforce tracking software',
  'mobile workforce management',
  'operations CRM',
  'field operations CRM',
  'field service management',
  'route tracking software',
  'customer visit tracking',
];

export const FIELD_TEAM_FAQ_KEYS = [
  { q: 'ftl_faq1_q', a: 'ftl_faq1_a' },
  { q: 'ftl_faq2_q', a: 'ftl_faq2_a' },
  { q: 'ftl_faq3_q', a: 'ftl_faq3_a' },
  { q: 'ftl_faq4_q', a: 'ftl_faq4_a' },
] as const;

type Translate = (key: string) => string;

export function buildFieldTeamJsonLd(opts: {
  origin: string;
  path: string;
  title: string;
  description: string;
  image: string;
  t: Translate;
  solutionSlug?: FieldTeamSolutionSlug | null;
}) {
  const url = `${opts.origin}${opts.path}`;
  const home = `${opts.origin}${FIELD_TEAM_PATH}`;
  const crumbs = [
    { '@type': 'ListItem', position: 1, name: 'TCards', item: `${opts.origin}/` },
    { '@type': 'ListItem', position: 2, name: opts.t('ftl_seo_site_name'), item: home },
  ];
  if (opts.solutionSlug) {
    crumbs.push({
      '@type': 'ListItem',
      position: 3,
      name: opts.t(`ftl_sol_${opts.solutionSlug}_title`),
      item: `${opts.origin}${SOLUTION_PATHS[opts.solutionSlug]}`,
    });
  }

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'TCards Field Team Tracking & Operations CRM',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web, Android, iOS',
      url,
      description: opts.description,
      image: opts.image,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: opts.title,
      description: opts.description,
      image: opts.image,
      brand: { '@type': 'Brand', name: 'TCards' },
      url,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'TCards',
      url: `${opts.origin}/`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FIELD_TEAM_FAQ_KEYS.map(({ q, a }) => ({
        '@type': 'Question',
        name: opts.t(q),
        acceptedAnswer: { '@type': 'Answer', text: opts.t(a) },
      })),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs,
    },
  ];
}
